import { toast } from 'react-toastify';
import Api from '../../Components/Api';
import { ORDER_TYPE, ORDER_TIME, PAYMENT_METHOD, PAYMENT, ORDER, DELIVERY_ADDRESS, GEOCODED_ADDRESS, EXTRA_ADDRESS, ORDER_LATER_DATETIME, SAVE_HBL_BANK_DATA, ACTIVE_PAYMENT_MODES, SET_POSITION, SET_SEARCH_STRING, SET_TAX } from './paymentTypes';
import jwt_decode from "jwt-decode";
import { GET_CART, HANDLE_SPECIAL_INPUT, HANDLE_ALT_NUM, RESET_DONATION } from './cartTypes';
import { SELECT_STORE } from './storeTypes';
import mergn from 'mergn-webapp-sdk'
import { resetCustomerDonation } from './cart';
import { getLocale } from '../../lib';
import { removeCoupon } from './menu';
var CryptoJS = require("crypto-js");

export const saveOrderType = (type: any) => {
  return function (dispatch: any) {
    dispatch({
      type: ORDER_TYPE,
      orderType: type,
    });
    sessionStorage.setItem("orderType", type)
    mergn.recordEvent('Order Type Select', [
      { eventProperty: 'order-type', value: type }
    ]);
  };
};

export const saveOrderTime = (period: any) => {
  return function (dispatch: any) {
    dispatch({
      type: ORDER_TIME,
      orderTime: period,
    });
    sessionStorage.setItem("orderTime", period)
  };
};

export const saveOrderLaterDateTime = (dateTime: any) => {
  return function (dispatch: any) {
    dispatch({
      type: ORDER_LATER_DATETIME,
      dateTime: dateTime
    });
  };
};

export const saveDeliveryAddress = (address: any) => {
  return function (dispatch: any) {
    dispatch({
      type: DELIVERY_ADDRESS,
      payload: address,
    });
  };
};
export const saveGeoCodedAddress = (address: any) => {
  return function (dispatch: any) {
    dispatch({
      type: GEOCODED_ADDRESS,
      payload: address,
    });
  };
};
export const saveExtraAddress = (address: any) => {
  return function (dispatch: any) {
    dispatch({
      type: EXTRA_ADDRESS,
      payload: address,
    });
  };
};


// type save pickup, payment method
export const emptyPaymentMethod = () => {
  return function (dispatch: any) {
    dispatch({
      type: PAYMENT_METHOD,
      paymentMethod: "",
    });
  };
};
export const savePaymentMethod = (payment_method: any) => {
  return function (dispatch: any) {
    dispatch({
      type: PAYMENT_METHOD,
      paymentMethod: payment_method,
    });
    if(payment_method !== "") {
      mergn.recordEvent('Select Payment Method')
    }
  };
};
export const saveCardPaymentLogs = (data: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.put(`customer/update_card_payment_logs`, { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
        }
      })
      .catch((err) => {
      });
  };
};

export const saveOrder = (data: any, setLoader: any, handleClose: any, setShowError: any, showErrorMessage: any, updateLoaderButton?: any, updateCartInOriginalStateAfterException?: any) => {

  return async (dispatch: any) => {
    let token: any = await localStorage.getItem("userToken");
    if (token) {
      var decoded: any = jwt_decode(token);
      data.customer_id = decoded.customer.customer_id;
    }
    data.authorization_key = process.env.REACT_APP_AUTHORIZATION_KEY
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`/customer/save_order`, { body: encryptedData })
      .then(async (response) => {
        if (response.data.success) {
          dispatch(saveOrderid(response.data.order_id))
          dispatch({
            type: GET_CART,
            payload: [],
          });
          dispatch({
            type: HANDLE_SPECIAL_INPUT,
            input: ""
          })
          dispatch({
            type: HANDLE_ALT_NUM,
            input: ""
          })
          dispatch({
            type: PAYMENT,
            successFlag: true,
          });
          dispatch(resetCustomerDonation())
          dispatch(removeCoupon())
          setLoader(false)
          handleClose();
          if (data.cartItems && data.cartItems.length > 0) {
            let cart: any = data.cartItems;
            let windowObj = (window as any)
            let products: any = []
            let MapObj: any = {}
            cart.forEach((cartItem: any) => {
              if (cartItem.item) {
                MapObj = {
                  quantity: cartItem.quantity,
                  price: cartItem.totalItemPrice,
                  id: cartItem.item.menu_item_id,
                  name: cartItem.item.item_name,
                  variant: cartItem.selectedsize.size
                }
              }
              else if (cartItem.combo) {
                MapObj = {
                  quantity: cartItem.quantity,
                  price: cartItem.totalItemPrice,
                  id: cartItem.combo.combo_id,
                  name: cartItem.combo.combo_name
                }
              }
              products.push(MapObj);
            })
            windowObj.dataLayer.push({ ecommerce: null });
            windowObj.dataLayer.push({
              'event': 'purchase',
              'ecommerce': {
                'currencyCode': 'PKR',
                'purchase': {
                  'actionField': {
                    'id': response.data.order_id,
                    'affiliation': 'KFC Online',
                    'revenue': data.order_grossprice,
                    'tax': data.tax_percent,
                  },
                  'products': products
                }
              }
            })
            windowObj.dataLayer.push({
              'event': 'paymentMethod',
              'ecommerce': {
                'select': {
                  'paymentMethod': data.payment_method
                }
              }
            });
          }
          setTimeout(() => {
            if (data.future_status && data.future_status == 1) {
              dispatch({
                type: ORDER_LATER_DATETIME,
                dateTime: null
              });
              dispatch({
                type: ORDER_TIME,
                dateTime: "now"
              });
              dispatch({
                type: SELECT_STORE,
                storeSelected: null,
              });
              dispatch({
                type: DELIVERY_ADDRESS,
                payload: null,
              });
              dispatch({
                type: GEOCODED_ADDRESS,
                payload: null,
              });
              dispatch({
                type: EXTRA_ADDRESS,
                payload: null,
              });
            }
          }, 2000);
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
            if (error.indexOf("Order Failed") > -1) {
              error = "Order Failed , try again later after clearing browser cache"
            }
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          // toast.error(error, {
          //   position: toast.POSITION.TOP_RIGHT,
          //   hideProgressBar: true,
          //   autoClose: 3000,
          // });
          updateCartInOriginalStateAfterException()
          updateLoaderButton()
          setShowError(true)
          showErrorMessage(error)
          setLoader(false)
          handleClose();
        } else {
        }
      });
  };
};
export const saveOrderSuccessFlag = () => {
  return function (dispatch: any) {
    dispatch({
      type: PAYMENT,
      successFlag: false,
    });
  };
};
export const saveOrderid = (order_id: any) => {
  return function (dispatch: any) {
    dispatch({
      type: ORDER,
      order_id: order_id,
    });
  };
};

export const saveCardOrder = (data: any, updateLoaderButton: any, updateCartInOriginalStateAfterException: any, setShowPaymentPending: any, showPaymentPendingMessage: any, handleClose: any) => {

  return async (dispatch: any) => {
    let token: any = await localStorage.getItem("userToken");
    if (token) {
      var decoded: any = jwt_decode(token);
      data.customer_id = decoded.customer.customer_id;
    }
    data.authorization_key = process.env.REACT_APP_AUTHORIZATION_KEY
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`/customer/deva_ramakanth_shukla_otc`, { body: encryptedData })
      .then(async (response) => {
        if (response.data.success) {
          if (data.payment_method == "Card") {
            dispatch({
              type: SAVE_HBL_BANK_DATA,
              payload: response.data.inputResponse
            })
            setTimeout(() => {
              let doc = document as any;
              let form: any = doc.getElementById("payment_confirmation");
              form && form.submit();
              dispatch({
                type: SAVE_HBL_BANK_DATA,
                payload: []
              })
            }, 1000)

          } else if (data.payment_method == "JazzWallet") {
            if (response.data.order) {
              dispatch(dumpCardTempOrder(response.data.order))
            } else {
              dispatch({
                type: GET_CART,
                payload: [],
              });
              dispatch({
                type: HANDLE_SPECIAL_INPUT,
                input: ""
              })
              dispatch({
                type: HANDLE_ALT_NUM,
                input: ""
              });
              dispatch(resetCustomerDonation())
              dispatch(removeCoupon())
              setShowPaymentPending(true)
              showPaymentPendingMessage(response.data.message)
              // toast.info(response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
              updateLoaderButton()
              handleClose()
            }
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
            if (error.indexOf("Order Failed") > -1) {
              error = "Order Failed , try again later after clearing browser cache"
            }
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          updateLoaderButton()
          updateCartInOriginalStateAfterException()
          toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
        } else {
        }
      });
  };
};
export const dumpCardTempOrder = (order: any, orderTime?: any) => {
  return async (dispatch: any) => {
    dispatch(saveOrderid(order.order_id))
    dispatch({
      type: GET_CART,
      payload: [],
    });
    dispatch({
      type: HANDLE_SPECIAL_INPUT,
      input: ""
    })
    dispatch({
      type: HANDLE_ALT_NUM,
      input: ""
    })
    dispatch({
      type: PAYMENT,
      successFlag: true,
    });
    dispatch(resetCustomerDonation())
    dispatch(removeCoupon())
    dispatch(savePaymentMethod(""));
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'currencyCode': 'PKR',
        'purchase': {
          'actionField': {
            'id': order.order_id,
            'affiliation': 'KFC Online',
            'revenue': order.order_grossprice,
            'tax': order.tax_percent,
          }
        }
      }
    })
    windowObj.dataLayer.push({
      'event': 'paymentMethod',
      'ecommerce': {
        'select': {
          'paymentMethod': order.payment_method
        }
      }
    });
    setTimeout(() => {
      if (orderTime && orderTime == "later") {
        dispatch({
          type: ORDER_LATER_DATETIME,
          dateTime: null
        });
        dispatch({
          type: ORDER_TIME,
          dateTime: "now"
        });
        dispatch({
          type: SELECT_STORE,
          storeSelected: null,
        });
        dispatch({
          type: DELIVERY_ADDRESS,
          payload: null,
        });
        dispatch({
          type: GEOCODED_ADDRESS,
          payload: null,
        });
        dispatch({
          type: EXTRA_ADDRESS,
          payload: null,
        });
      }
    }, 2000);

  };
};

export const submitHBLFormDAta = (hblObj: any, setLoader: any) => {
  return async (dispatch: any) => {
    var HBLencryptedData = CryptoJS.AES.encrypt(JSON.stringify(hblObj), process.env.REACT_APP_EncryptionKey).toString();
    Api.post("/customer/hbl_bank_mobile_payment", { body: HBLencryptedData }).then(async (response: any) => {
      if (response.data.success) {
        dispatch({
          type: SAVE_HBL_BANK_DATA,
          payload: response.data.successResponse
        })
        setTimeout(() => {
          let doc = document as any;
          let form: any;
          form = hblObj.card_token == null ? doc.getElementById("payment_confirmation") : doc.getElementById("token_payment_confirmation");
          form && form.submit();
          dispatch({
            type: SAVE_HBL_BANK_DATA,
            payload: []
          })
        }, 1000)
      }
    }).catch((err: any) => {
      dispatch({
        type: SAVE_HBL_BANK_DATA,
        payload: []
      })
      setLoader(false)
    })
  };
};

export const getPaymentModes = (store_id: number) => {
  return async (dispatch: any) => {
    dispatch({
      type: ACTIVE_PAYMENT_MODES,
      payload: []
    });
    Api.get(`menu/payment_modes/${store_id}`, {
      headers: {
        'locale': getLocale()
      }
    })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: ACTIVE_PAYMENT_MODES,
            payload: response.data.successResponse
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
          dispatch({
            type: ACTIVE_PAYMENT_MODES,
            payload: []
          });
        } else {
          alert("Connection Lost!!");
        }
      });
  };
};

export const setPositionProps = (value: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: SET_POSITION,
      position: value
    });
  }
}


export const setSearchStringProps = (value: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: SET_SEARCH_STRING,
      searchString: value
    });
  }
}

export const saveTrackingLogs = (body: any) => {
  return async (dispatch: any) => {
    var logs = CryptoJS.AES.encrypt(JSON.stringify(body), process.env.REACT_APP_EncryptionKey).toString();
    Api.post("/customer/payment_tracking", { body: logs }).then(async (response: any) => { }).catch((err: any) => { })
  };
};

export const getTax = (data: any) => {
  return async (dispatch: any) => {
    let token: any = localStorage.getItem("userToken")
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post("/customer/store_inclusive", { body: encryptedData }, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then(async (response: any) => {
        if (response.data.success) {
          dispatch({
            type: SET_TAX,
            payload: response.data.success
          })
        }
      })
      .catch((err: any) => {
        dispatch({
          type: SET_TAX,
          payload: false
        })
      });
  }
}